<template>
  <div class="maxh-1bar scroll-y pa-3 d-flex">
    <div class="w-1/2 pa-3 d-flex flex-column">
      <VehicleDetails2 :vehicle="value" @reload="$emit('reload')" />

      <div class="py-6">
        <VehicleCounters :vehicle="value" @reload="$emit('reload')" />
      </div>
    </div>

    <div class="w-1/2 pa-3">
      <ConfigList2 :vehicle="value" />
    </div>
  </div>
</template>

<script>
import VehicleDetails2 from './VehicleDetails2.vue'
import ConfigList2 from './configs2/ConfigList.vue'
import VehicleCounters from './VehicleCounters.vue'

export default {
  tabTitle: 'Configuração',
  tabGroup: 'Veículo',
  components: {
    VehicleDetails2,
    ConfigList2,
    VehicleCounters
  },
  props: {
    value: { required: true }
  }
}
</script>

<style></style>
